<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('titleTimeFormat')" class="col-sm-4 col-form-label">Title time</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('titleTimeFormat')" v-model.lazy="titleTimeFormat">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('titleScore')" class="col-sm-4 col-form-label">Title score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('titleScore')" v-model.lazy="titleScore">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Athlete</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('intermediateColumn')" class="col-sm-4 col-form-label">Intermediate</label>
        <div class="col-sm-8">
          <input type="number" class="form-control" :id="safeId('intermediateColumn')"
                 v-model.lazy.number="intermediateColumn" min="1"/>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Time</label>
        <div class="col-sm-8">
          <div class="mt-1 btn-group btn-group-justified">
            <button class="btn btn-primary"
                    title="Ctrl + I" @click="takeIm()">IM
            </button>
            <button class="btn btn-secondary"
                    title="Ctrl + E" @click="takeEnd()">END
            </button>
            <button class="btn btn-success"
                    title="Ctrl + T" @click="takeTop()">TOP
            </button>
            <button class="btn btn-warning"
                    title="Ctrl + C" @click="clear()">CLR
            </button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">IM: {{ intermediateColumn || 'IM?'}}</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="intermediateTime">
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" v-model.lazy="score">
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Show</label>
        <div class="col-sm-8">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" :name="safeId('show')" v-model="show"
                     value="time">Time</label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" :name="safeId('show')" v-model="show"
                     value="score">Score</label>
          </div>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('clockId')" class="col-sm-4 col-form-label">Clock</label>
        <div class="col-sm-8">
          <template-select :id="safeId('clockId')" v-model="clockId"></template-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label :for="safeId('maxRecords')" class="col-sm-4 col-form-label">Max records</label>
          <div class="col-sm-8">
            <input type="number" class="form-control" :id="safeId('maxRecords')" v-model.lazy="maxRecords">
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import * as lib from '../../lib'
  import { templateMixin } from '@/mixins'
  import { compare, mapOverlayData, mapTemplateData, mapTemplateOptions, rank } from '@/utils'
  import * as action from '@/store/action-types'
  import * as mutation from '@/store/mutation-types'
  import RecordSelect from '../ui/record-select'

  export default {
    components: {RecordSelect},
    name: 'uiaa-intermediate-standings',
    mixins: [templateMixin],
    data () {
      return {
        localShow: 'time',
        columnDefinitions: {
          'bibNumber': 'Bib number',
          'lastName': 'Last name',
          'firstName': 'First name',
          'country': 'Country',
          'score': 'Score'
          // 'endTime': 'Time'
        },
        intermediateTimeMs: null
      }
    },
    mounted () {
      this.$shortcut.bind('ctrl + i', () => this.takeIm())
      this.$shortcut.bind('ctrl + e', () => this.takeEnd())
      this.$shortcut.bind('ctrl + t', () => this.takeTop())
      this.$shortcut.bind('ctrl + c', () => this.clear())
    },
    computed: {
      ...mapOverlayData({'titleTime': {default: 'CLIP'}, 'titleScore': {default: 'STANDINGS'}}),
      ...mapOverlayData({'show': {default: 'time'}}),
      ...mapOverlayData({'timeRecords': {default: []}, 'rankRecords': {default: []}}),
      ...mapTemplateData(['clockId', 'datasetId', 'recordId', 'intermediateColumn']),
      // eslint-disable-next-line
      ...mapTemplateData({'titleTimeFormat': {default: 'CLIP #${IM} OF X'}}),
      ...mapTemplateData({columnMap: {default: {}}}),
      ...mapTemplateOptions({'maxRecords': {type: Number, default: 12}}),
      score: {
        get () {
          if (!this.dataset || !this.recordId) return null
          const record = this.dataset.records.find(r => r.recordId === this.recordId)
          if (!record) return null
          return record[this.columnMap['score']]
        },
        set (val) {
          this.updateCell(this.columnMap['score'], val)
        }
      },
      intermediateTime () {
        if (!this.dataset || !this.recordId) return null
        const record = this.dataset.records.find(r => r.recordId === this.recordId)
        if (!record) return null
        return record[this.intermediateColumn]
      },
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      records () {
        const dataset = this.dataset
        if (!dataset) return []
        return [].concat(dataset.records.map(record => {
          const result = this.mapRecord(record, this.columnMap)
          // Map recordId to find current record after sorting and ranking
          result.recordId = record.recordId
          // Map rawTime for further calculations
          result.rawTime = lib.timeStrToInt(result.time)
          result.timeDiff = result.time
          result.active = record.recordId === this.recordId
          return result
        }))
      },
      timeRecords () {
        let records = this.records
          .filter(each => each['time'])
        records.sort((a, b) => {
          return a.rawTime - b.rawTime
        })
        // Calculate time diff to leader
        const leader = records.find(r => r.recordId !== this.recordId)
        if (leader) {
          const baseRawTime = leader.rawTime
          leader.timeDiff = leader.time
          records.forEach(each => {
            if (each.recordId === leader.recordId) return each
            each.timeDiff = lib.formatTimeDiff(each.rawTime - baseRawTime)
          })
        }
        return this.sliceRecords(records, this.recordId)
      },
      rankRecords () {
        let records = this.records
          .filter(each => each['score'])
        records.sort((a, b) => {
          return compare.uiaaLeadScore(a['score'], b['score'])
        })

        // Rank records according to score
        records.forEach(rank('rank', 'score'))
        return this.sliceRecords(records, this.recordId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      intermediateColumn: function () {
        this.titleTime = this.titleTimeFormat.replace(/\${IM}/ig, this.intermediateColumn)
        this.show = 'time'
      },
      show: function (val) {
        this.localShow = val
      },
      timeRecords: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {timeRecords: val}
        })
      },
      rankRecords: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {rankRecords: val}
        })
      }
    },
    methods: {
      mapRecord (record, columnMap) {
        columnMap['time'] = this.intermediateColumn
        return Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
      },
      takeIm () {
        this.show = 'time'
        this.updateIntermediate(this.getStopwatch(), this.intermediateColumn + '.000')
      },
      takeEnd () {
        this.show = 'score'
        this.updateEnd(this.getStopwatch())
      },
      takeTop () {
        this.show = 'score'
        this.updateTop(this.getStopwatch())
      },
      clear () {
        this.updateCell(this.intermediateColumn, '')
      },
      getStopwatch () {
        const data = this.$store.getters.overlayData(this.clockId)
        if (!data || data === {}) return console.warn('[intermediate-standings] clock overlay data is empty')
        return new lib.Stopwatch(data)
      },
      updateIntermediate (stopwatch, score) {
        let time = null
        if (stopwatch) {
          let elapsed = new Date(stopwatch.elapsedMs)
          time = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2)
        }
        this.updateCell(this.intermediateColumn, time)
        // this.updateCell(this.columnMap['endTime'], time)
        this.updateCell('ENDTIME', time)
        this.updateCell(this.columnMap['score'], score)
      },
      updateEnd (stopwatch) {
        if (!stopwatch) return
        const elapsed = new Date(stopwatch.elapsedMs)
        const endTime = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2)
        // this.updateCell(this.columnMap['endTime'], endTime)
        this.updateCell('ENDTIME', endTime)
      },
      updateTop (stopwatch) {
        if (!stopwatch) return
        let elapsed = new Date(stopwatch.elapsedMs)
        const endTime = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2)
        const score = 'TOP(' + elapsed.getMinutes() + '.' + ('0' + elapsed.getSeconds()).slice(-2) + ')'
        // this.updateCell(this.columnMap['endTime'], endTime)
        this.updateCell('ENDTIME', endTime)
        this.updateCell(this.columnMap['score'], score)
      },
      updateCell (column, value) {
        this.$store.commit(mutation.DATASET_UPDATE_VALUE, {
          datasetId: this.datasetId,
          recordId: this.recordId,
          column,
          value,
          emit: true
        })
      },
      sliceRecords (records, recordId) {
        const maxRecords = this.maxRecords
        // Save index of current athlete
        let idx = records.findIndex(each => each.recordId === recordId)

        // If current athlete is in top (maxRecords), return top (maxRecords)
        if (idx < maxRecords) {
          return records.slice(0, maxRecords)
        }

        // Otherwise return top (maxRecords - 1) with current athlete at the end
        const record = records[idx]
        records = records.slice(0, maxRecords - 1)
        records.push(record)
        return records
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-lead-intermediate-standings.vue